import { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import Tooltip from 'Components/UI/Tooltip';
import { AvatarWrapperWithTooltip } from 'Components/UI/Tooltip/styles';
import { GetAvatar } from 'Utils/generateThumbnail';
import { ListSharedUsers, ObraAvatar } from './styles';

export interface IObrasItem {
  userIsAdmin?: boolean;
  currentPeperUser?: number;
  openUsuariosEPermissoes: (userToEdit: any) => void | undefined;
  currentUser?: any;
  disabled?: boolean;
}

const ObrasItem: FC<IObrasItem> = ({
  userIsAdmin,
  openUsuariosEPermissoes,
  currentUser,
  currentPeperUser,
  disabled
}) => {
  const { t } = useTranslation('gerenciarUsuarios');
  const filteredWorks = useMemo(() => {
    return currentUser?.ConstructionSites?.filter(
      (obra: any) => obra.IsShared === true
    )
  }, [currentUser]);

  const displayWorks = useCallback(() => {
    if (filteredWorks && filteredWorks.length > 5) {
      const visibleUsers = filteredWorks.slice(0, 4);

      const works = filteredWorks.slice(4);

      const usersList = (
        <ListSharedUsers>
          {works.map((work: any, index: number) => (
            <label key={`worksLabe${index}`}>{work.ConstructionSiteName}</label>
          ))}
        </ListSharedUsers>
      );

      return (
        <>
          {visibleUsers.map((sharedObra: any, index: any) =>
            <Tooltip
              title={sharedObra?.ConstructionSiteName}
              placement="bottom"
              key={`SharedUser${index}`}
            >
              <AvatarWrapperWithTooltip>
                <GetAvatar
                  name={sharedObra?.ConstructionSiteName}
                  shape='circle'
                  size={28}
                  src={sharedObra?.AvatarFileName}
                />
              </AvatarWrapperWithTooltip>
            </Tooltip>
          )}

          <Tooltip title={usersList} placement="bottom">
            <Button shape="circle" type="default" className="buttomListUser">
              +{works.length}
            </Button>
          </Tooltip>
        </>
      )
    }

    return (
      filteredWorks.map((sharedObra: any, index: any) =>
        <Tooltip
          title={sharedObra?.ConstructionSiteName}
          placement="bottom"
          key={`sharedObra${index}`}
        >
          <AvatarWrapperWithTooltip>
            <GetAvatar
              name={sharedObra?.ConstructionSiteName}
              shape='circle'
              size={28}
              src={sharedObra?.AvatarFileName}
            />
          </AvatarWrapperWithTooltip>
        </Tooltip>
      )
    )
  }, [currentUser]);

  return (
    <div>
      <ObraAvatar data-testid="avatares-obra">
        {displayWorks()}
        <Tooltip title={t('obrasItem.shareWork')} placement="bottom">
          {userIsAdmin || currentPeperUser === 3 ? (
            <></>
          ) : (
            <Button
              shape="circle"
              className="buttomUser"
              onClick={() => openUsuariosEPermissoes(currentUser)}
              disabled={disabled}
              style={disabled ? { display: 'none' } : { marginLeft: '4px' }}
            >
              +
            </Button>
          )}
        </Tooltip>
      </ObraAvatar>
    </div>
  );
}

export default ObrasItem;
